import {TileLayer, Layer, XYZ, LayerGroup, TileImage, OSM} from '../models'
import Axios from 'axios'
import {getMapService} from '../reducers/map'

class BasemapHelper {
  public ownMapsList = [] as any
  public pupMapsList = [] as any
  private tiffsLoaded = false
  private pupsLoaded = false
  public ownMapNames = new Map()
  public pupYear = new Map()
  public pupQuarter = new Map()
  public pupEkatte = new Map()
  public ownMapcenter = new Map()

  public getGoogleBasemaps = () => ['google-roadmap', 'google-satellite', 'google-hybrid', 'google-terrain'] as any
  public getEsriBasemaps = () => ['esri-topo', 'esri-satellite'] as any
  public getOsmBasemaps = () => ['osm', 'open-topo', 'etk'] as any
  public getWindyBasemaps = () => ['windy-tourist'] as any
  public getCartodbBasemaps = () =>
    ['cartodb-light', 'cartodb-darkmatter', 'cartodb-light-nolabels', 'cartodb-darkmatter-nolabels'] as any
  public getStamenBasemaps = () => ['stamen-terrain', 'stamen-watercolor', 'stamen-toner', 'stamen-toner-light'] as any
  public getEmptyMap = () => ['empty'] as any
  public ownMaps = () => this.ownMapsList as any
  public pupMaps = () => this.pupMapsList as any
  public getAllBasemaps = () =>
    [
      ...this.getGoogleBasemaps(),
      ...this.getEsriBasemaps(),
      ...this.getOsmBasemaps(),
      ...this.getWindyBasemaps(),
      ...this.getCartodbBasemaps(),
      ...this.getStamenBasemaps(),
      ...this.getEmptyMap(),
      ...this.ownMaps()
    ] as any

  public getFree(): any {
    return [...this.getOsmBasemaps(), ...this.getStamenBasemaps()] as any
  }
  getNonComerical(): string[] {
    return [...this.getOsmBasemaps(), ...this.getStamenBasemaps(), ...this.getCartodbBasemaps()]
  }
  // VIOLATES GOOGLE TOS
  public getGoogleBasemap(key: string): Layer {
    let source = new TileImage({
      url: 'https://mt1.google.com/vt/lyrs=m&hl=bg&x={x}&y={y}&z={z}',
      crossOrigin: 'Anonymous'
    })

    if (key == 'google-satellite') {
      source = new TileImage({
        url: 'https://mt1.google.com/vt/lyrs=s&hl=bg&x={x}&y={y}&z={z}&s=Ga',
        crossOrigin: 'Anonymous'
      })
    }
    if (key == 'google-hybrid') {
      source = new TileImage({
        url: 'https://mt1.google.com/vt/lyrs=y&hl=bg&x={x}&y={y}&z={z}',
        crossOrigin: 'Anonymous'
      })
    }
    if (key == 'google-terrain') {
      source = new TileImage({
        url: 'https://mt1.google.com/vt/lyrs=p&hl=bg&x={x}&y={y}&z={z}',
        crossOrigin: 'Anonymous'
      })
    }
    const layer = new TileLayer({
      source: source
    })
    return layer
  }

  public getEsriBasemap(key: string): Layer {
    if (key == 'esri-topo') {
      return new TileLayer({
        source: new XYZ({
          attributions:
            'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
          crossOrigin: 'Anonymous'
        })
      })
    } else if (key == 'esri-satellite') {
      return new LayerGroup({
        layers: [
          new TileLayer({
            source: new XYZ({
              attributions:
                'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
              crossOrigin: 'Anonymous'
            })
          }),
          new TileLayer({
            source: new XYZ({
              attributions:
                'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
              crossOrigin: 'Anonymous'
            })
          })
        ]
      })
    }
    return new TileLayer({
      source: new XYZ({
        attributions:
          'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        crossOrigin: 'Anonymous'
      })
    })
  }

  public getOsmBasemap(key: string): Layer {
    if (key == 'open-topo') {
      return new TileLayer({
        source: new XYZ({
          attributions:
            '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors' +
            ', ' +
            '<a href="https://opentopomap.org" target="_blank">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/" target="_blank">CC-BY-SA</a>)',
          url: 'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'etk') {
      return new TileLayer({
        source: new XYZ({
          url: 'https://drone.alfagis.bg/etk/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'drone') {
      return new TileLayer({
        source: new XYZ({
          url: 'https://drone.alfagis.bg/drone/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    return new TileLayer({
      source: new OSM()
    })
  }

  public getWindyBasemap(key: string): Layer {
    if (key == 'windy-tourist') {
      return new TileLayer({
        source: new XYZ({
          attributions:
            '&copy;<a href="https://www.seznam.cz/" target="_blank">Seznam.cz a.s.</a>' +
            ', ' +
            '&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
          url: 'https://windytiles.mapy.cz/turist-m/{z}-{x}-{y}',
          crossOrigin: 'Anonymous'
        })
      })
    }
    return new TileLayer({
      source: new XYZ({
        attributions:
          '&copy;<a href="https://www.seznam.cz/" target="_blank">Seznam.cz a.s.</a>' +
          ', ' +
          '&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
        url: 'https://windytiles.mapy.cz/turist-m/{z}-{x}-{y}',
        crossOrigin: 'Anonymous'
      })
    })
  }

  public getCartodbBasemap(key: string): Layer {
    const att =
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
    if (key == 'cartodb-light') {
      return new TileLayer({
        source: new XYZ({
          attributions: att,
          url: 'https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'cartodb-darkmatter') {
      return new TileLayer({
        source: new XYZ({
          attributions: att,
          url: 'https://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'cartodb-light-nolabels') {
      return new TileLayer({
        source: new XYZ({
          attributions: att,
          url: 'https://{a-c}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'cartodb-darkmatter-nolabels') {
      return new TileLayer({
        source: new XYZ({
          attributions: att,
          url: 'https://{a-c}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    return new TileLayer({
      source: new XYZ({
        attributions: att,
        url: 'https://cartodb-basemaps-{a-c}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        crossOrigin: 'Anonymous'
      })
    })
  }

  public getStamenBasemap(key: string): Layer {
    const tonerAtt =
      'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.'
    const waterAtt =
      'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>.'
    if (key == 'stamen-terrain') {
      return new TileLayer({
        source: new XYZ({
          attributions: tonerAtt,
          url: 'https://stamen-tiles-a.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'stamen-toner') {
      return new TileLayer({
        source: new XYZ({
          attributions: tonerAtt,
          url: 'https://stamen-tiles-{a-c}.a.ssl.fastly.net/toner-background/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    }
    if (key == 'stamen-toner-light') {
      return new TileLayer({
        source: new XYZ({
          attributions: tonerAtt,
          url: 'https://stamen-tiles-{a-c}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png',
          crossOrigin: 'Anonymous'
        })
      })
    } else if (key == 'stamen-watercolor') {
      return new TileLayer({
        source: new XYZ({
          attributions: waterAtt,
          url: 'https://stamen-tiles-{a-c}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg',
          crossOrigin: 'Anonymous'
        })
      })
    }
    return new TileLayer({
      source: new XYZ({
        attributions: tonerAtt,
        url: 'https://tile.stamen.com/terrain/{z}/{x}/{y}.jpg',
        crossOrigin: 'Anonymous'
      })
    })
  }
  public getOwnBasemap(key: string): Layer {
    if (this.ownMapcenter.has(key) && this.ownMapcenter.get(key) != null) {
      const t = this.ownMapcenter.get(key).split(',')
      const center = [parseFloat(t[0]), parseFloat(t[1])]
      const minzoom = this.pupMapsList.indexOf(key) != -1 ? 20 : 18
      if (getMapService().getZoom() < minzoom) {
        getMapService().setCenter(center)
      }
      if (getMapService().getZoom() < 14) {
        getMapService().setZoom(14)
      }
    }

    return new TileLayer({
      source: new XYZ({
        url: 'https://drone.alfagis.bg/' + key + '/output/{z}/{x}/{y}.png',
        crossOrigin: 'Anonymous'
      })
    })
  }

  public async getOwnMap() {
    if (this.tiffsLoaded) return
    this.tiffsLoaded = true
    const response = await Axios.get(process.env.HOST_API_URL + '/GetTiffs')
    for (let i = 0; i < response.data.length; i++) {
      if (response.data[i].Status != 1) continue
      this.ownMapsList.push(response.data[i].path)
      this.ownMapNames.set(response.data[i].path, response.data[i].Name)
      this.ownMapcenter.set(response.data[i].path, response.data[i].center)
    }
  }

  public static GetPupType(type: number) {
    switch (type) {
      case 0:
        return 'ПУП - ПРЗ'
      case 1:
        return 'ПУП - ПР'
      case 2:
        return 'ПУП - ПУР'
      case 3:
        return 'ПУП - ПЗ'
      case 4:
        return 'ПУП - РУП'
      case 5:
        return 'ПУП'
    }
  }

  public async GetPupMaps() {
    if (this.pupsLoaded) return
    this.pupsLoaded = true
    const response = await Axios.get(process.env.HOST_API_URL + '/GetPups')
    for (let i = 0; i < response.data.length; i++) {
      if (response.data[i].Status != 1) continue
      const quarter = response.data[i].Quarter == 'null' ? '' : 'кв. ' + response.data[i].Quarter

      const path = response.data[i].path.split('/')[0]
      const name =
        response.data[i].EKATTE +
        ' - ' +
        quarter +
        ' - ' +
        BasemapHelper.GetPupType(response.data[i].PupType) +
        ' - ' +
        response.data[i].Year +
        ' г. ' +
        response.data[i].Description

      this.pupMapsList.push(path)
      this.pupYear.set(path, response.data[i].Year)
      this.pupQuarter.set(path, response.data[i].Quarter)
      this.pupEkatte.set(path, response.data[i].EKATTE)
      this.ownMapNames.set(path, name)
      this.ownMapcenter.set(path, response.data[i].center)
    }
  }
}

export const basemapHelper = new BasemapHelper()
